export const ROOM_STATUS = { en: 'Room status', th: 'สถานะที่พัก' }

export const PLACE_DETAIL = { en: 'Place detail', th: 'รายละเอียดที่พัก' }

export const RENTAL_PRICE = { en: 'Rental price', th: 'ราคาเช่า' }

export const OWNER_STATUS = { en: 'Status', th: 'สถานะการยืนยัน' }

export const RENTAL_HISTORY = { en: 'History', th: 'ประวัติการเช่า' }

export const BROKER = { en: 'Broker', th: 'นายหน้า' }

export const BROKER_LIST = { en: 'Broker list', th: 'รายชื่อนายหน้า' }

export const LISTING_VIEWS = {
  en: '{n, plural, =1 {listing view} other {listing views}}',
  th: 'จำนวนการดู',
}

export const LOCATION = { en: 'Location', th: 'ตำแหน่งที่พัก' }

export const ROOM_TYPE = { en: 'Room type', th: 'ประเภทห้อง' }

export const AREA = { en: 'Area (sq.m.)', th: 'พื้นที่ (ตร.ม.)' }

export const BEDROOMS = { en: 'Bedrooms', th: 'ห้องนอน' }

export const BATHROOMS = { en: 'Bathrooms', th: 'ห้องน้ำ' }

export const FLOOR = { en: 'Floor', th: 'ชั้น' }

export const PLACE_RATING = { en: 'Place rating', th: 'คะแนนที่พัก' }

export const LAST_MODIFIED = { en: 'Last modified', th: 'แก้ไขล่าสุด' }

export const ANNOUNCEMENT = { en: 'Announcement', th: 'ประกาศ' }

export const RENEW = { en: 'Renew', th: 'ต่ออายุ' }

export const SEE_PLACE_DETAILS = {
  en: 'See place details',
  th: 'ดูรายละเอียดที่พัก',
}

export const EDIT_RENTAL_DETAILS = {
  en: 'Edit rental details',
  th: 'แก้ไขสัญญาเช่า',
}

export const EDIT_LISTING = { en: 'Edit listing', th: 'แก้ไขประกาศ' }

export const DELETE_LISTING = { en: 'Delete listing', th: 'ลบรายการ' }

export const MAKE_AS_RENTED = { en: 'Make as rented', th: 'ปิดการเช่า' }

export const MAKE_AS_AVAILABLE = { en: 'Make as available', th: 'เปิดให้เช่า' }
